import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "sub_top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("원격 관제시스템"),
  /*#__PURE__*/_createElementVNode("span", null, "Remote Control System")
], -1)
const _hoisted_7 = { class: "inner remoteSystem" }
const _hoisted_8 = { class: "img_box" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 원격 관제시스템은 관제소에 설치된 PC 또는 모바일을 통해 안전게이트 위치 및 상태를 확인하고 열기/닫기/비상 정지 등 원격 제어 기능을 할 수 있는 서비스입니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 원격 관제시스템은 지도보기 모드와 CCTV보기 모드를 제공하며 지도보기 모드에서는 설치된 전체 안전게이트의 위치와 상태를 한 눈에 파악이 가능하고 CCTV보기 모드에서는 실시간 모니터링이 가능합니다. ")
], -1)
const _hoisted_11 = { class: "img_box" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "desc txt_ct" }, "지도보기에서는 안전게이트의 위치를 한눈에 확인하고 원하는 안전게이트를 클릭하여 상세보기 및 개폐 실행을 할 수 있습니다.", -1)
const _hoisted_14 = { class: "img_box" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "desc txt_ct" }, "CCTV 화면에서는 전체 안전게이트의 현황을 실시간으로 확인하고 상황에 필요한 개폐 실행을 즉각 할 수 있습니다.", -1)
const _hoisted_17 = { class: "img_box" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "안전게이트 리스트 화면에서는 지도상에 표시된 안전게이트의 상태를 간편하게 확인하고 개폐를 실행하고자 하는 안전게이트를 여러 개 선택해서 동시에 실행할 수 있습니다.", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "sub_tit" }, [
  /*#__PURE__*/_createTextVNode("시스템 구성도"),
  /*#__PURE__*/_createElementVNode("p", null, "System Configuration Diagram")
], -1)
const _hoisted_21 = { class: "img_box" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", { class: "sub_tit" }, [
  /*#__PURE__*/_createTextVNode("추가 시스템"),
  /*#__PURE__*/_createElementVNode("p", null, "Additional System")
], -1)
const _hoisted_24 = { class: "box system" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "list_tit" }, "스마트 안전게이트 원격 관제시스템에 적용 가능한 추가 시스템으로는 CCTV, 수위 센서/인체 감지 센서 그리고 태양광 또는 풍력을 이용한 친환경 에너지 발전기 등이 있습니다.", -1)
const _hoisted_26 = { class: "remoteSystem_list" }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "안전 게이트가 설치된 진출입로 주변에 전용 CCTV를 설치하여 원격 관제시스템에서 진출입로의 상황을 실시간으로 모니터링할 수 있습니다.", -1)
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "보조 시스템으로 설치 가능한 센서로는 하천 수면의 높이를 측정하는 수위 센서와 안전게이트 주변 진출입로에 사람을 감지하는 인체 감지 센서가 있습니다.", -1)
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "산악도로, 등산로 등 전기 및 유선 통신 설비의 설치가 어려운 곳에 태양광 또는 풍력 스마트 게이트를 설치하여 차수문, 진입 차단문 등을 운영할 수 있습니다.", -1)

import bg_sub_top from "@/assets/images/pages/bg_sub_top.jpg";
import m_bg_sub_top from "@/assets/images/pages/m_bg_sub_top.jpg";
import img_remote_system01 from "@/assets/images/pages/img_remote_system01.jpg";
import img_remote_system02 from "@/assets/images/pages/img_remote_system02.jpg";
import img_remote_system03 from "@/assets/images/pages/img_remote_system03.jpg";
import img_remote_system04 from "@/assets/images/pages/img_remote_system04.jpg";
import img_remote_system05 from "@/assets/images/pages/img_remote_system05.jpg";
import img_system01 from "@/assets/images/pages/img_system01.png";
import img_system02 from "@/assets/images/pages/img_system02.png";
import img_system03 from "@/assets/images/pages/img_system03.png";
export default {
  setup(__props) {


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(bg_sub_top),
          alt: "PC 배경이미지",
          class: "pc"
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          src: _unref(m_bg_sub_top),
          alt: "모바일 배경이미지",
          class: "mw"
        }, null, 8, _hoisted_5),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: _unref(img_remote_system01),
            alt: "관제시스템 pc/mw 이미지"
          }, null, 8, _hoisted_9)
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            src: _unref(img_remote_system02),
            alt: "관제시스템 지도보기 이미지"
          }, null, 8, _hoisted_12)
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("img", {
            src: _unref(img_remote_system03),
            alt: "관제시스템 cctv화면 이미지"
          }, null, 8, _hoisted_15)
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("img", {
            src: _unref(img_remote_system04),
            alt: "관제시스템 리스트 이미지"
          }, null, 8, _hoisted_18)
        ]),
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("img", {
            src: _unref(img_remote_system05),
            alt: "시스템 구성도 이미지"
          }, null, 8, _hoisted_22)
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("ul", _hoisted_26, [
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                src: _unref(img_system01),
                alt: "시스템 아이콘"
              }, null, 8, _hoisted_27),
              _hoisted_28
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                src: _unref(img_system02),
                alt: "시스템 아이콘"
              }, null, 8, _hoisted_29),
              _hoisted_30
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                src: _unref(img_system03),
                alt: "시스템 아이콘"
              }, null, 8, _hoisted_31),
              _hoisted_32
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

}